import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom';
import { Button } from 'antd';

export function BtnInfoFinish(props){
  let { url, completions } = props.course;
  
  if(Object.keys(completions).length === props.course.length){
    return (
      <Link to={`/poet/${url.poet}`}>
        <Button
          id="btn-info-finish"
          icon="check"
          style={props.style}
          >
          Finish
        </Button>
      </Link>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnInfoFinish.js